import {LastResult} from '@hconnect/common/types'
import {isFinite, toNumber} from 'lodash'
import moment, {Moment} from 'moment-timezone'

export const isValueError = (lastResult?: LastResult): boolean => {
  if (lastResult?.value) {
    return lastResult?.value.toString().startsWith('ERR_')
  }
  return false
}

export const isValueCorrectNumber = (lastResult?: LastResult): boolean =>
  !!lastResult?.value && isFinite(toNumber(lastResult?.value))

export function parseAndFormatTimeRange(timeRange: string | undefined): {
  formatted: string[]
  moments: [Moment, Moment] | undefined
} {
  if (!timeRange) return {formatted: [], moments: undefined}
  const dateStrings = timeRange.replace(/[\\[\]\s]/g, '').split(',')
  if (!Array.isArray(dateStrings) || dateStrings.length < 2)
    return {formatted: [], moments: undefined}
  const formatted = dateStrings.map((dateStr) =>
    new Date(dateStr).toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
  )
  return {
    formatted,
    moments: [moment(dateStrings[0]), moment(dateStrings[1])]
  }
}
